/**
 * Weather as a launch decision.
 *
 * There is no feed — the operator enters what they observe, and the server
 * turns it into the components and margins a go/no-go actually turns on. The
 * maths is server-side so this verdict is the same one a pre-flight check or a
 * replay would compute.
 */

import { api, type ApiResult } from '@/api/client';

export type WeatherVerdict = 'ok' | 'caution' | 'no-go';

export interface WeatherFactor {
  name: string;
  verdict: WeatherVerdict;
  detail: string;
}

export interface WeatherAssessment {
  verdict: WeatherVerdict;
  /** Positive into wind, negative a tailwind on the landing heading. */
  headwindMs: number;
  crosswindMs: number;
  gustFactorMs: number;
  densityAltitudeM: number;
  summary: string;
  factors: WeatherFactor[];
}

export interface WeatherRequest {
  windSpeedMs: number;
  windFromDeg: number;
  headingDeg: number;
  gustMs?: number;
  temperatureC?: number;
  fieldElevationM?: number;
  maxWindMs?: number;
  maxCrosswindMs?: number;
  maxGustMs?: number;
}

export function assessWeather(body: WeatherRequest): Promise<ApiResult<WeatherAssessment>> {
  return api.post<WeatherAssessment>('/weather/assess', body, { logged: false });
}
